import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useTrackPageView } from '@/core/tracking/_hooks/useTrackPageView';

import { useIdToken } from '../../store/auth/authSelectors';
import { paths } from '../paths';

// Used when AWS Cognito auth service is used
export const PublicRoute = ({ children }: { children: ReactNode }) => {
	const idToken = useIdToken();

	useTrackPageView({ skip: !idToken });

	if (idToken) {
		return <Navigate to={paths.home} replace />;
	}

	return <>{children}</>;
};
